import(/* webpackMode: "eager" */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AppErrorBoundary"] */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/components/AppErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlbModelsFromRoute"] */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/components/GlbModelsFromRoute.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalAudioFeedback"] */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/components/GlobalAudioFeedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LandscapeBlocker"] */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/components/LandscapeBlocker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VpnNotice"] */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/components/VpnNotice.tsx");
;
import(/* webpackMode: "eager" */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/node_modules/animate.css/animate.css");
;
import(/* webpackMode: "eager" */ "/opt/gitflic-runner/build/job-be6c4182-ba38-43d5-9472-bd1f5c892dc3/node_modules/next/dist/client/script.js");
